import { Instance, types } from 'mobx-state-tree'

export enum NotificationType {
  successTransaction = 'successTransaction',
  failedTransaction = 'failedTransaction',
  downTime = 'downTime',
  chargeBacks = 'chargeBacks',
  lowBalance = 'lowBalance',
  txnReportGen = 'txnReportGen',
  refundReportGen = 'refundReportGen',
  bulkRefundReportGen = 'bulkRefundReportGen',
  settlementReportGen = 'settlementReportGen',
  profileChange = 'profileChange',
  supportTicketUpdates = 'supportTicketUpdates',
  userAccountUpdates = 'userAccountUpdates',
}

const NotificationSetting = types.model('NotificationSetting', {
  type: types.enumeration(Object.values(NotificationType)),
  channel: types.array(types.string),
})

const notificationSettingData = NotificationSetting.create({
  type: NotificationType.successTransaction,
  channel: ['Y', 'n', 'n'],
})

export { NotificationSetting, notificationSettingData }
export type NotificationSettingV2 = Instance<typeof NotificationSetting>
